import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
  Input,
  Alert,
  ModalFooter,
  Button,
} from "reactstrap";
import AppSpinner from "../../elements/AppSpinner";

const DeleteModuleModal = ({
  open,
  toggle,
  onDelete,
  moduleName,
  submitting,
  error,
}) => {
  const [confirmName, setConfirmName] = useState("");

  return (
    <Modal isOpen={open} toggle={toggle} className="modal-dialog-centered">
      <ModalHeader toggle={toggle}>Delete Data Source</ModalHeader>
      <ModalBody>
        Type the name
        <Badge
          color="light"
          className="mx-2"
          style={{ position: "relative", top: "-2px" }}
        >
          {moduleName || ""}
        </Badge>
        below to delete this data source:
        <Input
          className="form-control mt-3"
          type="text"
          value={confirmName}
          onChange={(e) => setConfirmName(e.target.value)}
          placeholder={moduleName || "Delete"}
        />
        {error && (
          <Alert color="warning" className="mb-0 mt-3">
            {error}
          </Alert>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={toggle}>
          Cancel
        </Button>
        <Button
          color="danger"
          onClick={onDelete}
          disabled={
            submitting ||
            !moduleName ||
            !confirmName ||
            moduleName.toLowerCase() !== confirmName.toLowerCase()
          }
          style={{ width: 100 }}
        >
          {submitting ? <AppSpinner size="sm" color="white" /> : "Delete"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModuleModal;
